import { Box, Button } from "@noom/wax-component-library";
import { useTranslation } from "react-i18next";

import {
  MedCtaAction,
  trackPrescriptionWebviewCtaTapped,
} from "../../nativeAnalytics/medAnalytics";

type LabResultsCtaProps = {
  medicationName: string;
  onViewResults: () => void;
};

export const LabResultsCta = ({
  medicationName,
  onViewResults,
}: LabResultsCtaProps) => {
  const { t } = useTranslation("care", { useSuspense: false });
  const ctaLabel = t("detail.resultsCard.cta");

  return (
    <Box>
      <Button
        data-cy="lab-results-card-cta"
        size="sm"
        variant="solid"
        colorScheme="primary"
        onClick={() => {
          void trackPrescriptionWebviewCtaTapped({
            ctaText: ctaLabel,
            context: "status_card",
            medicationName,
            ctaAction: MedCtaAction.ViewResults,
          });
          onViewResults();
        }}
      >
        {ctaLabel}
      </Button>
    </Box>
  );
};
